import { render, staticRenderFns } from "./CompareWidget.vue?vue&type=template&id=2ddc10fe&scoped=true"
import script from "./CompareWidget.vue?vue&type=script&lang=js"
export * from "./CompareWidget.vue?vue&type=script&lang=js"
import style0 from "./CompareWidget.vue?vue&type=style&index=0&id=2ddc10fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ddc10fe",
  null
  
)

export default component.exports